import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, post } from 'aws-amplify/api';
import {
	DraftModel,
	RHYME_API_SERVICES,
	StandardResponse,
	ValidationError,
	SubmitData,
} from 'type-declarations';
import { fixBackendValidationErrorIssues } from './fix-backend-errors-utilities';

const rhymeApiUrl = RHYME_API_SERVICES.RhymeApi;

export async function sdgService_ValidateSdg(
	orgId: string,
	caseId: string,
	submissionId: string,
	correctionData: Partial<SubmitData>
): Promise<StandardResponse | null> {
	const path = `organization/${orgId}/case/${caseId}/submission/${submissionId}/data-gathering/validate`;

	const options = {
		body: { dataToValidate: correctionData } as unknown as FormData,
	};
	try {
		await post({
			apiName: rhymeApiUrl,
			path: path,
			options,
		}).response;
		return null;
	} catch (error) {
		if (
			error instanceof ApiError &&
			error.response &&
			error.response.statusCode === 400 &&
			error.response.body
		) {
			const response = JSON.parse(error.response.body);
			return response;
		} else throw error;
	}
}

export const validateSdgData = createAsyncThunk(
	'transaction-thunk/validate-sdg-data',
	async ({
		orgId,
		caseId,
		submissionId,
		correctionData,
	}: {
		orgId: string;
		caseId: string;
		submissionId: string;
		correctionData: Partial<SubmitData>;
	}) => {
		const validationResponse = await sdgService_ValidateSdg(
			orgId,
			caseId,
			submissionId,
			correctionData
		);
		return validationResponse;
	}
);

async function referral_Validate(correctionData: DraftModel): Promise<ValidationError[] | null> {
	const { organizationId, partnerCaseId, referral } = correctionData;
	const path = `organization/${organizationId}/draft/${partnerCaseId}/validate?setDefaults=false`;

	const options = {
		body: { ...referral } as unknown as FormData,
	};
	try {
		await post({
			apiName: rhymeApiUrl,
			path: path,
			options,
		}).response;
		return null;
	} catch (error) {
		if (
			error instanceof ApiError &&
			error.response &&
			error.response.statusCode === 424 &&
			error.response.body
		) {
			const formatedResponse = JSON.parse(error.response.body);
			return formatedResponse.errors;
		} else throw error;
	}
}

export const validateReferral = createAsyncThunk(
	'transaction-thunk/validate-referral',
	async ({ correctionData }: { correctionData: DraftModel }) => {
		const validationResponse = await referral_Validate(correctionData);
		return fixBackendValidationErrorIssues(validationResponse!);
	}
);
